<template>
    <swiper
        ref="swiper"
        class="swiper basic relative z-10 transition flex-grow-0 duration-300"
        :class="{ 'opacity-0': isLoading, 'opacity-100': ! isLoading }"
        @swiper="onSwiper"
        :slides-per-view="4"
        :space-between="0"
        :scrollbar="{ draggable: true }"
        :breakpoints="{
            320:  { slidesPerView: 1 },
            720:  { slidesPerView: 2 },
            960:  { slidesPerView: 3 },
            1280: { slidesPerView: 4 },
        }"
        :grab-cursor="true"
        :loop="true"
    >
        <swiper-slide class="swiper-slide px-12 text-sm" v-for="(slide, index) in swiperData">
            <div class="flex mb-4 w-full">
                <img class="w-6" v-for="star in slide.stars" :src="star" alt="★">
            </div>
            <div class="pb-2 pb-1 pl-3 border-l-4">
                {{ slide.text }}
            </div>
            <div class="text-hh-grey pt-1 pl-3">
                {{ slide.name }}, {{ slide.date }}
            </div>
        </swiper-slide>

        <div
            class="left-2 lg:-left-0"
            :class="[navButtonCSS(), { 'opacity-0': isLoading, 'opacity-100': ! isLoading }]"
            @click="prevSlide()"
            v-show="showNavButtons"
        >
            <img class="rounded-full p-1 w-6 rotate-180" src="/assets/img/frontend-v3/icons/global/icon-right-angle-grey-50.svg" alt="previous">
        </div>
        <div
            class="right-2 lg:-right-0"
            :class="[navButtonCSS(), { 'opacity-0': isLoading, 'opacity-100': ! isLoading }]"
            @click="nextSlide()"
            v-show="showNavButtons"
        >
            <img class=" rounded-full p-1 w-6" src="/assets/img/frontend-v3/icons/global/icon-right-angle-grey-50.svg" alt="next">
        </div>
    </swiper>
</template>

<script>
// :observer="true"
// :observeParents="true"

import { Swiper, SwiperSlide } from 'swiper/vue';

export default {

    name: 'SwiperNpsReviews',

    props: ['swiper-data'],

    components: {
        Swiper,
        SwiperSlide,
    },

    data() {
        return {
            isLoading: true,
            showNavButtons: true,
            swiperSlides: {},
            defaultOptions: {
                loop: true,
            },
        }
    },

    created() {

    },

    mounted() {
        this.$nextTick(() => {
            this.showNavButtons = this.showNav();
        })

        this.isLoading = false;
    },

    methods: {

        onSwiper(swiper) {
            this.swiper = swiper;
        },

        showNav() {
            return true;
        },

        isOnFirstSlide() {
            return this.isLoading ? false : (this.swiper?.isBeginning ?? false);
        },

        isOnLastSlide() {
            return this.isLoading ? false : (this.swiper?.isEnd ?? false);
        },

        nextSlide() {
            this.swiper.slideNext();
        },

        prevSlide() {
            this.swiper.slidePrev();
        },

        stopLoading() {
            const referenceLoader = document.querySelector('[data-loader-reference="' + this.reference + '"]');
            referenceLoader.classList.add('hidden');
        },

        navButtonCSS() {
            return 'inline-flex items-center justify-center rounded-full absolute top-1/2 -translate-y-1/2 w-8 h-8 bg-hh-cyan mr cursor-pointer select-none duration-300 z-10 touch-manipulation';
        },

    }
};
</script>
